(() => {
  function reducer(state, action) {
    switch (action.type) {
      case 'UPDATE':
        state = action.value;
        break;

      default:
        break;
    }
    return state;
  }

  window.park.app({
    container: 'navigation',
    component: 'navigation',
    reducer,
  }).then((app) => {
    const state = app.store.getState();
    const url = state.ajax.url;
    const fetch = () => window.park.ajax(`${window.park.exports.config.rootBase}${url}`);

    fetch()
      .then((result) => {
        result
          .json()
          .then((result) => {
            app.store.dispatch({
              type: 'UPDATE',
              value: result,
            });
            window.park.console.info('Navigation fetch returned JSON');
          })
          .catch(() => {
            result.text().then((result) => {
              document.addEventListener('park.menu-manager:open', () => {
                window.park.console.info('Menu is opened.');
                if (window.park.decryptLinks) setTimeout(() => window.park.decryptLinks(), 1000);
                else window.park.console.warn('There is no `decryptLinks` method in `park`.');
              });
              app.insertHTML(result);
              window.park.console.info('Navigation fetch returned HTML');
            });
          });
      });
  });
})();



// WEBPACK FOOTER //
// ./src/widgets/navigation/navigation.js